import { apiConfig } from '../config/credentials'

export interface BetaSignupData {
  email: string
  name: string
  dietaryPreferences?: string[]
  householdSize?: number
  primaryGroceryStore?: string
  referralSource?: string
}

export interface BugReportData {
  title: string
  description: string
  severity?: 'low' | 'medium' | 'high' | 'critical'
  category?: string
  stepsToReproduce?: string[]
  expectedBehavior?: string
  actualBehavior?: string
  screenshotUrls?: string[]
  url?: string
  email?: string
}

export interface FeatureRequestData {
  title: string
  description: string
  category?: string
  useCase?: string
  email?: string
}

export const betaApiService = {
  // Beta Signups
  async submitBetaSignup(data: BetaSignupData) {
    const response = await fetch(`${apiConfig.baseUrl}/api/beta-signups`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    return response.json()
  },

  async getBetaStats() {
    const response = await fetch(`${apiConfig.baseUrl}/api/beta-signups/stats`)
    return response.json()
  },

  // Bug Reports
  async submitBugReport(data: BugReportData) {
    const response = await fetch(`${apiConfig.baseUrl}/api/bug-reports`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    return response.json()
  },

  async getBugReports() {
    const response = await fetch(`${apiConfig.baseUrl}/api/bug-reports`)
    return response.json()
  },

  // Feature Requests
  async submitFeatureRequest(data: FeatureRequestData) {
    const response = await fetch(`${apiConfig.baseUrl}/api/feature-requests`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    return response.json()
  },

  async getFeatureRequests() {
    const response = await fetch(`${apiConfig.baseUrl}/api/feature-requests`)
    return response.json()
  },

  async upvoteFeature(featureId: string) {
    const response = await fetch(`${apiConfig.baseUrl}/api/feature-requests/${featureId}/upvote`, {
      method: 'POST',
    })
    return response.json()
  },

  // Surveys
  async getActiveSurveys() {
    const response = await fetch(`${apiConfig.baseUrl}/api/surveys/active`)
    return response.json()
  },

  async submitSurveyResponse(surveyId: string, data: { responses: any; timeToCompleteSeconds?: number }) {
    const response = await fetch(`${apiConfig.baseUrl}/api/surveys/${surveyId}/responses`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    return response.json()
  }
}
